import {Component, inject} from "@angular/core";
import {Translations} from "@translations";
import {SharedModule} from "../../../../../../../shared/shared.module";
import {AutomaticRecordingSessionDialogStore} from "../../store/automatic-recording-session-dialog.store";
import {ScheduleEntryComponent} from "../schedule-entry/schedule-entry.component";

@Component({
	selector: "sim-automatic-recording-session-step2",
	imports: [SharedModule, ScheduleEntryComponent],
	templateUrl: "./automatic-recording-session-step2.component.html",
	styleUrl: "./automatic-recording-session-step2.component.scss",
})
export class AutomaticRecordingSessionStep2Component {
	protected readonly T = Translations;

	protected readonly store = inject(AutomaticRecordingSessionDialogStore);
}
